import { render, staticRenderFns } from "./jobView.vue?vue&type=template&id=66b862c6&scoped=true&"
import script from "./jobView.vue?vue&type=script&lang=ts&"
export * from "./jobView.vue?vue&type=script&lang=ts&"
import style0 from "./jobView.vue?vue&type=style&index=0&id=66b862c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b862c6",
  null
  
)

component.options.__file = "jobView.vue"
export default component.exports